import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2ArrowLeftOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path d="m7.172 17 1.155-2h21.845l-1.154 2zm6.338 8.978-8.993-9.98 8.946-9.978-1.49-1.336L1.829 16.001l10.196 11.315z" /></svg>
);
